import { setIdentifierGenerationMethod } from '@ember-data/store';
import { dasherize } from '@ember/string';

// RFC-4122 v4 generator with no external dependency.
// crypto.randomUUID() only exists in secure contexts (https/localhost);
// crypto.getRandomValues() also works in insecure contexts, so keep a fallback.
function uuidv4() {
  if (window.crypto?.randomUUID) {
    return crypto.randomUUID();
  }
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = [...bytes].map((b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export function initialize() {
  // see this GH issue for more information https://github.com/emberjs/data/issues/8106
  // Ember Data 4.x generates ids with a crypto call that is not available in unsecure contexts,
  // so we define our own id generation method (suggested polyfill landed in 4.6.2).
  // https://api.emberjs.com/ember-data/4.5/classes/IdentifierCache/methods/getOrCreateRecordIdentifier?anchor=getOrCreateRecordIdentifier
  // adapted from defaultGenerationMethod -- https://github.com/emberjs/data/blob/v4.5.0/packages/store/addon/-private/identifier-cache.ts#LL82-L94C2
  setIdentifierGenerationMethod((data) => {
    if (data.lid) {
      return data.lid;
    }
    if (data.id) {
      return `@lid:${dasherize(data.type)}-${data.id}`;
    }
    return uuidv4();
  });
}

export default {
  name: 'ember-data-identifiers',
  initialize,
};
